import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Transaction } from "../../../model/transaction";
import { Observable } from "rxjs";

@Injectable()
export class TransactionsJsonServerService {
  private baseUrl = "http://localhost:3000"; // Or whatever

  constructor(private http: HttpClient) {}

  getAllTransactions(): Observable<Transaction[]> {
    return this.http.get<Transaction[]>(`${this.baseUrl}/transactions`);
  }

  getMyTransactions(user) {
    return this.http.get<Transaction>(`${this.baseUrl}/transactions/${user}`);
  }
  getTransaction(id) {
    return this.http.get<Transaction>(`${this.baseUrl}/transactions/${id}`);
  }

  addTransaction(transaction: Transaction) {
    return this.http.post(`${this.baseUrl}/transactions`, transaction);
  }

  updateTransaction(transaction: Transaction) {
    console.log(transaction);

    return this.http.put(
      `${this.baseUrl}/transactions/${transaction.id}`,
      transaction
    );
  }

  saveTransaction(transaction: Transaction) {
    if (transaction.id) {
      return this.updateTransaction(transaction);
    } else {
      return this.addTransaction(transaction);
    }
  }

  deleteTransaction(transaction: Transaction) {
    console.log(transaction);
    console.log(transaction.id);

    return this.http.delete(`${this.baseUrl}/transactions/${transaction.id}`);
  }
}
